<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <div v-if="watermark == '1'">
      <Watermark :watermarkText="watermarkText" :key="watermark" />
    </div>
  </div>
</template>

<script>
import Watermark from '@/components/waterMark/waterMark.vue'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    Watermark
  },
  computed: {
    watermark() {
      return this.$store.state.user.watermark;
    }
  },
  data() {
    return {
      isRouterAlive: true,
      watermarkText: '这是水印文本',
      // watermark: this.$store.state.user.watermark, // 水印  1开启水印 2关闭水印
      datekey:Date.now()
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss">
@import '/assets/font/iconfont.css';
@import '/assets/font/myIcon.css';
/*cover*/
.el-button,
.el-table,
.el-form-item__label,
.el-form-item__content,
.el-input,
.el-radio,
.el-radio--medium.is-bordered .el-radio__label,
.el-radio__label,
.el-select-dropdown__item,
.el-checkbox__label,
.el-pagination__sizes .el-input .el-input__inner,
.el-pager li,
.el-divider__text, .el-link,
.el-picker-panel__shortcut,
.el-dialog__body,
.el-tree-node__label,
.el-tabs__item{
  font-size: 12px;
}
.el-tabs__item{ font-weight: bold;}

.el-dialog__body{ padding:10px 20px;}

.el-input__inner[type='number']{ padding-right: 0;}

.dialog-footer button{ padding: 9px 15pxs;}

body .el-table th.gutter{
   display: table-cell!important;
}

.displayflex{
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination{
  display: flex;
  justify-content:end;
}
</style>



// WEBPACK FOOTER //
// src/App.vue